import React from "react";

export default function DownloadAppButton({ logo, text, onclick }) {
  return (
    <div
      className="text-sm cursor-pointer flex space-x-4 justify-center items-center rounded-xl px-4 py-2 border border-primary text-primary bg-white hover:bg-primary hover:border-transparent hover:text-white transition duration-200"
      onClick={(event) => {
        event.preventDefault();
        onclick();
      }}
    >
      {logo}
      <p className="md:text-lg text-base">{text}</p>
    </div>
  );
}
